<template>
  <ul class="w-asideW flex-grow-0 flex-shrink-0" :class="[isCitizenM ? 'bg-black': 'bg-blue-700']">
    <NavItem :route="{name: 'jobs-list'}" title="Jobs" icon="jobs" />
    <NavItem :route="{name: 'record-statistics'}" title="Statistics" icon="stats" />
    <NavItem disabled route="#" title="Data Warehouse" icon="warehouse" />

     <div v-for="item in customMenuItems" :key="item.name" >
      <NavItem v-if="$checkPrivilege(item.privilege)" :route="{name: 'custom', params: {name: item.name}}" :title="item.title" :icon="item.icon" />
    </div>
  </ul>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import customMenu from '@/config/customMenu'
import { CUSTOMER_IDS } from '@/constants'
import NavItem from '@/components/aside/NavItem'

export default {
  name: 'TheAside',
  components: { NavItem },
  setup () {
    const store = useStore()

    const customerId = computed(() => store.getters['customers/customer'].ID)

    return {
      isCitizenM: computed(() => customerId.value === CUSTOMER_IDS.CITIZENM),
      customMenuItems: computed(() => Array.isArray(customMenu[customerId.value]) ? customMenu[customerId.value] : [])
    }
  }
}
</script>
